// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sitemap-section[data-v-797a0fbe]{padding:75px 0}h2[data-v-797a0fbe]{border-bottom-width:2px;border-bottom-style:solid;border-color:inherit;padding-bottom:4px;margin-bottom:.5em}ol[data-v-797a0fbe]{list-style:none;padding:0}li[data-v-797a0fbe]{padding-top:5px;padding-bottom:5px;font-size:1.125rem}.section[data-v-797a0fbe]{margin-bottom:4rem}.section[data-v-797a0fbe]:last-child{margin-bottom:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
